const lang = {
    common: {
        admin_header_title: "SaedaPostCard Admin",
        admin_header_logout: "ログアウト"
    }
}

export default lang;